export default { sha: 'cfc1a412fd72674ca1c7de8ee9f189126cf6ddf3', buildNumber: 'undefined' }
